import React from "react";
import { Avatar, Box, Container, Stack } from "@mui/material";
import { HEADER_HEIGHT } from "../../../../utils/ui.constants";
import { Link } from "react-router-dom";
import Notification from "./Notification";
import UserSetting from "../../layout/header/UserSetting";

function Header() {
  return (
    <Box sx={{ height: HEADER_HEIGHT, backgroundColor: "common.white" }}>
      <Container sx={{ height: "100%" }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ height: "100%" }}
        >
          <Link to="/">
            <Avatar
              src="/logo.svg"
              sx={{ width: "93px", height: "30px", borderRadius: "0px" }}
            />
          </Link>
          <Stack direction="row" alignItems="center" gap={2}>
            <Notification />
            <UserSetting options={[]} />
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
}

export default Header;
